import React, { createContext, useContext, useEffect, useState } from "react";
import CardDiv from "modules/common/card-div/CardDiv";
import EngagementsTabs from "modules/engagement_report/engagement_reports/EngagementsTabs";
import EngagementFilter from "./EngagementFilter";
import { Button } from "react-bootstrap";
import CloudIcon from "assets/svgs/cloud_icon";
import Calendar from "assets/svgs/calendar";
import { Select, Tooltip } from "antd";
import { useEngagementReport } from "./store";
import { useLocation } from "react-router-dom";
import EngagementDateFilter from "./EngagementDateFilter";
import SelectAssignee from "./SelectAssignee";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { isEmpty } from "lodash";
import { activeStatus, ENG_REP_DOWN, isDownloadDisabled } from "modules/utilities/utility";
import moment from "moment";
import { useAllOrderStore } from "modules/order_management/store";
import { attemptOption } from "config";

export const EngReportCont = createContext(null);

function EngagementReport({ slotBooking = false }) {
  const {
    fetchEngagements,
    downloadReport,
    updateLoading,
    updateEngRepData,
    downloadReportv2,
  } = useEngagementReport();
  const [agent, setAgent] = useState([]);
  const [tempAgents, setTempAgents] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [selectedAgent, setSelectedAgent] = useState([]);
  const [selectedTempAgent, setSelectedTempAgent] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [assign, setAssign] = useState(null);
  const [checkedFilter, setCheckedData] = useState([]);
  const [selectedGender, setSelectedGender] = useState("");
  const [orderFilter, setOrderFilter] = useState("");
  const [selectedLeadAgent, setSelectedLeadAgent] = useState([]);
  const [disableDownloadButton, setDisableDownloadButton] = useState(false);
  const [slotType, setSlotType] = useState([]);
  const [selectMaladAgent, setMaladSelectAgent] = useState([]);
  const [selectIvr, setIvrAgent] = useState([]);
  const [selectAttempt, setSelectAttempt] = useState(null);
  const [selectLead, setSelectLead] = useState(null);
  const [selectLocation, setSelectLocation] = useState(null);
  const [selectProcess, setSelectProcess] = useState(null);
  const [attemptStatus, setAttemptStatus] = useState("");
  const [selectReceptioninst, setSelectReceptioninst] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const urlStartDate = searchParams.get("startDate");
  const urlEndDate = searchParams.get("endDate");
  const tab = searchParams.get("tab");
  const { setToaster } = useToast();
  const { hourEngData, fetchHourlyEng } = useAllOrderStore();
  const [filterOrder, setFilterOrder] = useState([]);
  const [submitFlag, setSubmitFlag] = useState(0);

  useEffect(() => {
    const start = moment(urlStartDate).valueOf();
    const end = moment(urlEndDate).valueOf();
    fetchHourlyEng(start, end);
  }, [urlStartDate, urlEndDate]);

  useEffect(() => {
    if(!isEmpty(tab) && tab!=='undefined'){
      setActiveTab(tab);
    }
  }, []);

  useEffect(() => {
    setPage(1);
    setSelectedAgent([]);
    setSelectedTempAgent([]);
    setSelectedStatus("");
  }, [tab]);

  useEffect(() => {
    createFilterQuery();
  }, [
    setAgent,
    setTempAgents,
    selectedAgent,
    selectedTempAgent,
    selectedStatus,
    selectedLeadAgent,
    slotType,
    sortBy,
    selectMaladAgent,
    selectAttempt,
    attemptStatus,
    selectReceptioninst,
    // orderFilter,
    // selectedGender
  ]);

  useEffect(() => {
    setPage(1);
  }, [sortBy]);

  const createFilterQuery = () => {
    let filters = [];
    let selectedAgentData = selectedAgent?.map((assignee) => assignee.value);
    let selectedTempAgentData = selectedTempAgent?.map(
      (assignee) => assignee.value
    );
    let selectedLeadAgentData = selectedLeadAgent?.map(
      (assignee) => assignee.value
    );
    let selectMaladLeadAgent = selectMaladAgent?.map(
      (assignee) => assignee.value
    );

    let selectClinicAgent = selectReceptioninst?.map(
      (assignee) => assignee.value
    );

    let selectReporingManagerAgent = selectLead?.map(
      (assignee) => assignee.value
    );

    let selectLocationData = selectLocation?.map((assignee) => assignee.value);

    let selectProcessData = selectProcess?.map((assignee) => assignee.value);
    if (selectedStatus && selectedStatus.length > 0) {
      const filterString = `status=${selectedStatus}`;
      filters.push(filterString);
    }

    if (selectedTempAgentData && selectedTempAgentData.length > 0) {
      const tempAgents = selectedTempAgentData.join(",");
      const filterString = `tempAgents=${tempAgents}`;
      filters.push(filterString);
    }

    if (selectedAgentData && selectedAgentData.length > 0) {
      const agents = selectedAgentData.join(",");
      const filterString = `agents=${agents}`;
      filters.push(filterString);
    }

    if (attemptStatus && attemptStatus.length > 0) {
      const filterString = `attemptFlag=${attemptStatus}`;
      filters.push(filterString);
    }

    if (selectAttempt && selectAttempt?.length > 0) {
      const filterString = `reattempt=${selectAttempt}`;
      filters.push(filterString);
    }

    if (selectedLeadAgentData && selectedLeadAgentData?.length > 0) {
      const agents = selectedLeadAgentData.join(",");
      const filterString = `agents=${agents}`;
      filters.push(filterString);
    }

    if (selectMaladLeadAgent && selectMaladLeadAgent?.length > 0) {
      const agents = selectMaladLeadAgent.join(",");
      const filterString = `agents=${agents}`;
      filters.push(filterString);
    }

    if (selectClinicAgent && selectClinicAgent?.length > 0) {
      const agents = selectClinicAgent.join(",");
      const filterString = `agents=${agents}&tempAgents=${agents}`;
      filters.push(filterString);
    }

    if (selectIvr && selectIvr?.length > 0) {
      const agents = selectIvr.join(",");
      const filterString = `agents=${agents}`;
      filters.push(filterString);
    }

    if (slotType && slotType?.length > 0 && slotType === "cold_call") {
      const filterString = `cold_call=true`;
      filters.push(filterString);
    }

    //Commented due to need to implement in future

    // if (selectedGender && selectedGender.length > 0) {
    //   const agents = selectedGender;
    //   const filterString = `gender=${agents}`;
    //   filters.push(filterString);
    // }

    // if (orderFilter && orderFilter.length > 0) {
    //   const agents = orderFilter;
    //   const filterString = `order=${agents}`;
    //   filters.push(filterString);
    // }

    if (sortBy && sortBy.length > 0) {
      const filterString = `sortBy=${sortBy}`;
      filters.push(filterString);
    }

    const filter = filters.join("&");
    if (filter && filter.length > 0) {
      setQuery("&" + filter);
    } else {
      setQuery("");
    }
  };
  
  useEffect(() => {
    fetchData();
  }, [
    activeTab,
    urlEndDate,
    urlStartDate,
    page,
    slotBooking && selectedStatus,
    slotBooking && query,
    pageSize,
    sortBy && query
    // slotBooking && attemptStatus,
  ]);
  useEffect(() => {
    if ((selectedStatus || selectLead) && slotBooking) {
      setPage(1);
    }
  }, [slotBooking && selectedStatus, slotBooking && attemptStatus]);

  const applyFilter = () => {
    setPage(1);
    fetchData();
  };

  const fetchData = () => {
    if (!isEmpty(activeTab) && activeTab !== "undefined") {
      let queryParam = query;
      queryParam = handleRepeatRetention(queryParam);
      if (slotBooking) {
        const start = moment(urlStartDate).valueOf();
        const end = moment(urlEndDate).valueOf();
        fetchEngagements(start, end, activeTab, queryParam, page, pageSize);
      } else {
        const start = moment(urlStartDate).startOf("day").valueOf();
        const end = moment(urlEndDate).endOf("day").valueOf();
        fetchEngagements(start, end, activeTab, queryParam, page, pageSize);
      }
    }
  };

  const clearFilter = () => {
    setPage(1);
    setSelectedAgent([]);
    setSelectedTempAgent([]);
    setSelectedStatus("");
    setSelectedLeadAgent([]);
    setQuery("");
    fetchData();
  };

  const handleAssign = () => {
    const checkedData = checkedFilter?.filter((item) => {
      return item.checked;
    });
    if (checkedData?.length == 0) {
      return;
    }

    const data = checkedData?.map((item) => {
      return {
        engagementId: item?._id,
        repId: assign,
      };
    });
    if (data?.length) {
      updateEngRepData(data, setToaster);
    }
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  const passValue = {
    checkedFilter: checkedFilter,
    setCheckedFilter: setCheckedData,
    hourEngData: hourEngData,
    selectLead: selectLead,
    selectLocation: selectLocation,
    selectProcess: selectProcess,
    filterOrder: filterOrder,
    setSelectLead: setSelectLead,
    setSelectLocation: setSelectLocation,
    setSelectProcess: setSelectProcess,
    submitFlag: submitFlag,
    setSubmitFlag: setSubmitFlag,
    pageSize:pageSize
  };

  const handleRepeatRetention = (queryParam) => {
    if (activeTab === "repeat_retention") {
      queryParam = queryParam.concat(`&repeat_retention=true`);
    }
    return queryParam;
  };
  const downloadEngagementReport = (setDisableDownloadButton, urlStartDate, urlEndDate, activeTab, query) => {
    let queryParam = query;
    queryParam = handleRepeatRetention(queryParam);
    downloadReportv2(setDisableDownloadButton, urlStartDate, urlEndDate, activeTab, queryParam);
  }

  return (
    <>
      <CardDiv
        title={
          <div className="d-flex gap-1 flex-wrap justify-content-between">
            {slotBooking ? null : <div className="fs-2">Engagement Report</div>}
            <div className="d-flex flex-row flex-wrap gap-2">
              <SelectAssignee
                assign={assign}
                setAssign={setAssign}
                handleAssign={handleAssign}
                updateLoading={updateLoading}
                slotBooking={slotBooking}
                hourEngData={hourEngData}
              />
              <EngagementDateFilter
                slotBooking={slotBooking}
                setSelectLead={setSelectLead}
                hourEngData={hourEngData}
                setSelectLocation={setSelectLocation}
                setSelectProcess={setSelectProcess}
                setFilterOrder={setFilterOrder}
                submitFlag={submitFlag}
                setSubmitFlag={setSubmitFlag}
                selectLead={selectLead}
                selectLocation={selectLocation}
                selectProcess={selectProcess}
                attemptStatus={attemptStatus}
              />
              {slotBooking && (
                <div className="mt-1" style={{ width: "100px" }}>
                  <Select
                    allowClear
                    placeholder="Status"
                    className="w-100"
                    onChange={(role) => {
                      setSelectedStatus(role);
                    }}
                    options={activeStatus}
                  />
                </div>
              )}
              {slotBooking && (
                <div className="mt-1 align-self-end" style={{ width: "100px" }}>
                  <Select
                    allowClear
                    placeholder="Attempt Status"
                    className="w-100"
                    onChange={(attempt) => {
                      setAttemptStatus(attempt);
                    }}
                    options={attemptOption}
                  />
                </div>
              )}
              <EngagementFilter
                selectedAgent={selectedAgent}
                setSelectedAgent={setSelectedAgent}
                selectedTempAgent={selectedTempAgent}
                setSelectedTempAgent={setSelectedTempAgent}
                selectedStatus={selectedStatus}
                setSelectedStatus={setSelectedStatus}
                setSelectedGender={setSelectedGender}
                setOrderFilter={setOrderFilter}
                agent={agent}
                tempAgents={tempAgents}
                applyFilter={applyFilter}
                clearFilter={clearFilter}
                selectedLeadAgent={selectedLeadAgent}
                setSelectedLeadAgent={setSelectedLeadAgent}
                slotType={slotType}
                setSlotType={setSlotType}
                activeTab={activeTab}
                selectMaladAgent={selectMaladAgent}
                setMaladSelectAgent={setMaladSelectAgent}
                setSelectAttempt={setSelectAttempt}
                selectIvr={selectIvr}
                setIvrAgent={setIvrAgent}
                selectReceptioninst={selectReceptioninst}
                setSelectReceptioninst={setSelectReceptioninst}
              />
              <Tooltip placement="top" title="Sent over email">
                <Button
                  variant="primary"
                  className="mt-1 float-end"
                  onClick={() => {
                    downloadReport(urlStartDate, urlEndDate, activeTab, query);
                  }}
                  disabled={isDownloadDisabled}
                >
                  <Calendar />
                </Button>
              </Tooltip>
              <Tooltip placement="top" title="Download">
                <Button
                  variant="primary"
                  className="mt-1 float-end"
                  disabled={isDownloadDisabled && ENG_REP_DOWN}
                  onClick={() => {
                    downloadEngagementReport(setDisableDownloadButton, urlStartDate, urlEndDate, activeTab, query);
                  }}
                >
                  <CloudIcon />
                </Button>
              </Tooltip>
            </div>
          </div>
        }
        component={
          <EngReportCont.Provider value={passValue}>
            <div className="text-end mt-n4">
              <Select
                id="pageSizeDropdown"
                value={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: 120 }}
              >
                {[10, 20, 30, 40, 50].map((size) => (
                  <Option key={size} value={size}>
                    {size} per page
                  </Option>
                ))}
              </Select>
            </div>
            <EngagementsTabs
              urlStartDate={urlStartDate}
              urlEndDate={urlEndDate}
              setAgent={setAgent}
              setTempAgents={setTempAgents}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              setPage={setPage}
              page={page}
              setSortBy={setSortBy}
              applyFilter={applyFilter}
              slotBooking={slotBooking}
              attemptStatus={attemptStatus}
              selectLead={selectLead}
              selectLocation={selectLocation}
              selectProcess={selectProcess}
            />
          </EngReportCont.Provider>
        }
      />
    </>
  );
}

export default EngagementReport;